import { render } from "./ListHistoryStock.vue?vue&type=template&id=0a66b0f8&scoped=true"
import script from "./ListHistoryStock.vue?vue&type=script&lang=js"
export * from "./ListHistoryStock.vue?vue&type=script&lang=js"

import "./ListHistoryStock.vue?vue&type=style&index=0&id=0a66b0f8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a66b0f8"]])

export default __exports__